﻿class HeroSlider extends HTMLElement {
  connectedCallback() {
    new Swiper(this, {
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
        pageUpDown: true,
      },
    });
  }
}

customElements.define('hero-slider', HeroSlider);

